import React from 'react';
import { Link } from "react-router-dom";
import { Auth } from 'aws-amplify';
import * as MESSAGES from '../Lib/Messages';
import Logo from './Logo';
import Notification from './Notification';
import InputError from './InputError';
import Validator from '../Lib/Validator';

class UserForgotPwd extends React.Component {
	constructor(props) {
		super();
		this.state = {
				email: '',
				errors: {},
				errorMessage: null
		};

		this.handleChange = this.handleChange.bind(this);
	}

	handleChange(event) {
		const { target: { name, value } } = event;
		this.setState({
			[name]: value
		});

		const { errors } = this.state;
		if(errors[name]) {
			delete errors[name];
		}
	}

	isValidation() {
		this.setState({errors: {}, errorMessage: ''});

		var errors = {};
		var isError = false;
		var validator = new Validator();

		if(!validator.required(this.state.email)) {
			errors['email'] = MESSAGES.ERROR_EMAIL;
			isError = true;
		}
		if(!window.navigator.onLine) {
			this.setState({ errorMessage: MESSAGES.ERROR_NETWORK_CONNECTION, isError: true });
			isError = true;
		}

		this.setState({ errors });
		if(isError) {
			return false;
		}

		return true;
	}

	handleResetPass = async (e) => {
		e.stopPropagation();
		e.preventDefault();

		if(!this.isValidation()) {
			return false;
		}

		const { history } = this.props;
		Auth.forgotPassword(this.state.email)
	    .then(data => {
			history.push('/user/reset_pwd');
		})
	    .catch(err => {
			if(err.message) {
				this.setState({errorMessage: err.message});
			} else {
				this.setState({errorMessage: MESSAGES.ERROR_FORGOT_PASSWORD});
			}
		});
	}

	render() {
		const { errors, errorMessage } = this.state;
		return (
	  		<section className="body-sign">
	  			<div className="center-sign">
					<Logo />
	  				<div className="panel card-sign">
	  					<div className="card-title-sign mt-3 text-right">
	  						<h2 className="title text-uppercase font-weight-bold m-0"><i className="fa fa-user mr-1"></i> Recover Password</h2>
	  					</div>
	  					<div className="card-body">
	  						<div className="alert alert-info">
	  							<p className="m-0">Enter your Email below and we will send you reset code!</p>
	  						</div>
	  						<form>
								<Notification isError={true} message={errorMessage} isPublic="true" />
	  							<div className={`form-group mb-0 ${errors.email ? 'has-danger' : null}`}>
	  								<div className="input-group">
	  									<input name="email" type="email" placeholder="Email" className="form-control form-control-lg" onChange={this.handleChange}/>
	  									<span className="input-group-btn">
	  										<button className="btn btn-primary btn-lg" type="submit" onClick={this.handleResetPass}>Reset!</button>
	  									</span>
	  								</div>
										<InputError error={errors.email} />
	  							</div>

	  							<p className="text-center mt-3">
									Remembered? <Link role="menuitem" tabIndex="-1" to="/user/signin">Sign In</Link> or <Link role="menuitem" tabIndex="-1" to="/user/reset_pwd">Change Password</Link>
								</p>
	  						</form>
	  					</div>
	  				</div>

	  				<p className="text-center text-muted mt-3 mb-3">© Copyright 2018. All Rights Reserved.</p>
	  			</div>
	  		</section>
    	)
	}
}

export default UserForgotPwd;
